import styled from "styled-components";
import { DINGY_GRAY, LIGHT_BLUE, LIGHT_GRAY, MATTE_BLACK, NEAR_WHITE, WHITE } from "../../config";

export const LengthBox = styled.div<{ isBarrierLayoutAllowed: boolean }>`
  display: flex;
  height: 24px;
  width: 32px;
  color: ${({ isBarrierLayoutAllowed }) => (isBarrierLayoutAllowed ? NEAR_WHITE : MATTE_BLACK)};
  background-color: ${({ isBarrierLayoutAllowed }) =>
    isBarrierLayoutAllowed ? LIGHT_BLUE : LIGHT_GRAY};
  border-radius: 6px;
  align-items: center;
  text-align: center;
  line-height: 24px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    color: ${WHITE};
    background-color: ${DINGY_GRAY};
  }
`;

export const Box = styled.div<{ hasIcon: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: ${({ hasIcon }) => !hasIcon && "16px"};
`;

export const Empty = styled.div`
  margin-left: 30px;
`;
